<template>
    <tr class="budget-io-detail">
        <!-- TODO: rozpadnout na dilci komponenty -->
        <td colspan="10" v-loading="loading" style="padding-left: 0; padding-right: 0">
            <template v-if="io">
                <div class="row" style="margin: 12px 0">
                    <div class="col-sm-6" style="display: flex; flex-direction: column; gap: 8px;">
                        <b>Received IO</b>
                        <div class="row">
                            <div class="col-sm-3 col-lg-2">
                                From
                            </div>
                            <div class="col-sm-9 col-lg-10">
                                to-do@agency.com
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-lg-2">
                                Subject
                            </div>
                            <div class="col-sm-9 col-lg-10">
                                Sample to-do subject
                            </div>
                        </div>
                        <div class="row" v-if="io.note">
                            <div class="col-sm-3 col-lg-2">
                                Note
                            </div>
                            <div class="col-sm-9 col-lg-10">
                                {{ io.note }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-lg-2">
                                Attachment
                            </div>
                            <div class="col-sm-9 col-lg-10">
                                <a :href="io.file_url" target="_blank">{{ io.file_name }}</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" style="display: flex; flex-direction: column; gap: 8px; padding-left: 24px">
                        <div><b>Proposed billing</b></div>

                        <el-alert
                            v-if="! io.is_identified"
                            title="Please select the employer and budget period"
                            type="warning"
                            show-icon
                            :closable="false"
                        />

                        <div style="display: flex; align-items: center; gap: 32px">
                            <div style="width: 50%">
                                <employer-dropdown
                                    v-model="form_data.employer_id"
                                    :employers="lists.employers"
                                    @change="setEmployer"
                                />
                            </div>

                            <div style="display: flex; align-items: center; gap: 24px">
                                <a :href="billingUrl" v-if="form_data.employer_id">
                                    Billing
                                </a>
                                <a :href="budgetUrl" v-if="form_data.employer_id">
                                    Budget
                                </a>
                            </div>
                        </div>


                        <div style="display: flex; align-items: center; gap: 32px">
                            <div style="width: 50%">
                                <el-select
                                    v-model="form_data.budget_period_id"
                                    filterable 
                                    placeholder="Select a budget period"
                                    :disabled="! form_data.employer_id"
                                    style="width: 100%"
                                    @change="setBudgetPeriod"
                                >
                                    <el-option
                                        v-for="item in lists.budget_periods"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="row" style="margin-top: 12px">
                    <div class="col-sm-6">
                        <div ref="pdf_preview" style="width: 100%; aspect-ratio: 16 / 22"></div>
                    </div>
                    <div class="col-sm-6" style="display: flex; flex-direction: column; padding-left: 24px">
                        <template v-if="billings && io.is_identified">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th style="width: 10%"></th>
                                        <th style="width: 25%; text-align: right">{{ billings.previous.title }}</th>
                                        <th style="width: 25%; text-align: right">{{ billings.current.title }}<br>(current)</th>
                                        <th style="width: 25%; text-align: right">{{ billings.proposed.title }}<br>(proposed)</th>
                                        <th style="text-align: right">Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Status</td>
                                        <td style="text-align: right">{{ billings.previous.status }}</td>
                                        <td style="text-align: right">{{ billings.current.status }}</td>
                                        <td style="text-align: right">{{ billings.proposed.status }}</td>
                                        <td style="text-align: right"></td>
                                    </tr>
                                    <tr>
                                        <td>Agency</td>
                                        <td style="text-align: right">{{ billings.previous.agency_name }}</td>
                                        <td style="text-align: right">{{ billings.current.agency_name }}</td>
                                        <td style="text-align: right">{{ billings.proposed.agency_name }}</td>
                                        <td style="text-align: right">{{ billings.changes.agency_name }}</td>
                                    </tr>
                                    <tr>
                                        <td>Discount</td>
                                        <td style="text-align: right">{{ billings.previous.discount }}</td>
                                        <td style="text-align: right">{{ billings.current.discount }}</td>
                                        <td style="text-align: right">{{ billings.proposed.discount }}</td>
                                        <td style="text-align: right">{{ billings.changes.discount }}</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle">IO No.</td>
                                        <td style="text-align: right; vertical-align: middle">{{ billings.previous.io_number }}</td>
                                        <td style="text-align: right; vertical-align: middle">{{ billings.current.io_number }}</td>
                                        <td class="align-right">
                                            <el-input v-model="form_data.io_number" style="text-align: right" @change="refreshTexts" />
                                        </td>
                                        <td style="text-align: right; vertical-align: middle"></td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle">Billable</td>
                                        <td style="text-align: right; vertical-align: middle">{{ billings.previous.billable }}</td>
                                        <td style="text-align: right; vertical-align: middle">{{ billings.current.billable }}</td>
                                        <td class="align-right">
                                            <el-input v-model="form_data.billable" @change="refreshTexts" />
                                        </td>
                                        <td style="text-align: right; vertical-align: middle">{{ billings.changes.billable }}</td>
                                    </tr>
                                    <tr>
                                        <td>Note</td>
                                        <td style="text-align: right">{{ billings.previous.note }}</td>
                                        <td style="text-align: right">{{ billings.current.note }}</td>
                                        <td class="align-right">
                                            <el-input
                                                type="textarea"
                                                :rows="5"
                                                v-model="form_data.note"
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>

                        <div v-if="billings && io.is_identified">
                            <el-checkbox v-model="is_email">Send Email Confirmation</el-checkbox>

                            <div v-if="is_email" style="display: flex; flex-direction: column; gap: 8px; margin: 16px 0">
                                <div style="display: flex">
                                    <div style="display: flex; align-items: center; width: 80px;">
                                        To:
                                    </div>
                                    <div style="flex: 1 1 0%">
                                        <el-input v-model="form_data.email_to" />
                                    </div>
                                </div>
                                <div style="display: flex">
                                    <div style="display: flex; align-items: center; width: 80px">
                                        CC:
                                    </div>
                                    <div style="flex: 1 1 0%">
                                        <el-input v-model="form_data.email_cc" />
                                    </div>
                                </div>
                                <div style="display: flex">
                                    <div style="display: flex; align-items: center; width: 80px">
                                        Subject:
                                    </div>
                                    <div style="flex: 1 1 0%">
                                        <el-input v-model="form_data.email_subject" />
                                    </div>
                                </div>
                                <div style="display: flex">
                                    <div style="width: 80px"></div>
                                    <div style="flex: 1 1 0%">
                                        <el-input v-model="form_data.email_body" type="textarea" :rows="9" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="display: flex; width: 100%; gap: 24px">
                            <div style="display: flex; flex-direction: column; flex: 1 0 60%; align-items: start; justify-content: flex-end">
                                <template v-if="billings && io.is_identified">
                                    <p style="margin: 16px 0 12px 0">
                                        <i>By clicking on the "Confirm IO" button, the IO PDF will be linked to "{{ io.employer_name }}" for the budget period of "{{ billings.proposed.title }}".</i>
                                    </p>
                                    <button
                                        type="button" 
                                        class="btn btn-lg btn-primary" 
                                        @click="confirm"
                                    >
                                        Confirm IO
                                    </button>
                                </template>
                            </div>
                            <div style="display: flex; flex-direction: column; flex: 1 1 40%; align-items: end; justify-content: flex-end">
                                <button 
                                    type="button" 
                                    class="btn btn-lg btn-secondary" 
                                    @click="archive"
                                >
                                    Archive IO
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
import PDFObject from 'pdfobject';

export default {
    props: {
        budget_io: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            form_data: {
                employer_id: null,
                budget_period_id: null,
                io_number: null,
                billable: null,
                note: null,
                email_to: "to-do@agency.com",
                email_cc: null,
                email_subject: "RE: to-do email subject",
                email_body: null,
            },
            io: null,
            billings: {},
            texts: {},
            lists: {
                employers: [],
                budget_periods: [],
            },
            is_email: false,
            loading: true,
        };
    },
    computed: {
        isPdf() {
            return this.io && this.io.file_extension === 'pdf';
        },
        budgetUrl() {
            return url(`admin/employer/${this.form_data.employer_id}/budgets`);
        },
        billingUrl() {
            return url(`admin/employer/${this.form_data.employer_id}/billing`);
        },
    },
    methods: {
        refresh() {
            this.loading = true;

            return axios.get(url(`admin/insertion-orders/${this.budget_io}/data`))
                .then((response) => {
                    this.io = response.data.io;
                    this.form_data = _.merge(this.form_data, response.data.form_data);
                    this.billings = response.data.billings;
                    this.texts = response.data.texts;
                    this.lists = response.data.lists;

                    this.loading = false;

                    this.refreshTexts();

                    Vue.nextTick(() => {
                        this.previewDocument();
                    });
                });
        },
        previewDocument() {
            if(this.isPdf) {
                const options = {
                    pdfOpenParams: {
                        view: 'FitV',
                        pagemode: 'none',
                    }
                };

                PDFObject.embed(this.io.file_url, this.$refs.pdf_preview, options);
            }
        },
        setEmployer() {
            return axios.post(url(`admin/insertion-orders/${this.budget_io}/set-employer`), {
                employer_id: this.form_data.employer_id,
            })
                .then((response) => {
                    this.refresh();
                });

        },
        setBudgetPeriod() {
            return axios.post(url(`admin/insertion-orders/${this.budget_io}/set-budget-period`), {
                budget_period_id: this.form_data.budget_period_id,
            })
                .then((response) => {
                    this.refresh();
                });

        },
        confirm() {
            return axios.post(url(`admin/insertion-orders/${this.budget_io}/confirm`))
                .then((response) => {
                    // this.$message({
                    //     message: `The IO has been confirmed`,
                    //     type: 'success'
                    // });

                    this.$emit("refresh");
                });

        },
        archive() {
            return axios.post(url(`admin/insertion-orders/${this.budget_io}/archive`))
                .then((response) => {
                    // this.$message({
                    //     message: `The IO has been archived`,
                    //     type: 'success'
                    // });

                    this.$emit("refresh");
                });

        },
        refreshTexts() {
            this.form_data.note = this.replaceText(this.texts.templates.billing_note);
            this.form_data.email_body = this.replaceText(this.texts.templates.email_body);
        },
        replaceText(text) {
            text = text.replace('{month}', this.texts.variables.month);
            text = text.replace('{employer}', this.texts.variables.employer);
            text = text.replace('{ioNumber}', this.form_data.io_number);
            text = text.replace('{netTotal}', this.money(this.form_data.billable));
            text = text.replace('{grossTotal}', this.money(this.form_data.billable / (1-this.texts.variables.agency_discount)));

            return text;
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style scoped>
    td {
        background-color: #fff;
    }
    td.align-right >>> .el-input__inner {
        text-align: right
    }
</style>